exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab-header[data-v-5f114b5a]{height:45px;line-height:45px;font-size:16px;margin-top:15px;border-top:1px solid #d9e0e6;border-bottom:1px solid #d9e0e6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-5f114b5a","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/electronicMedicalRecord/patient/parts/dialysisInfo/cancelRecords/index.vue
// module id = KV5W
// module chunks = 0